// Generated by purs version 0.13.0
"use strict";
var Chip_Action = require("../Chip.Action/index.js");
var Chip_Action_AI = require("../Chip.Action.AI/index.js");
var Chip_Action_MovePlayer = require("../Chip.Action.MovePlayer/index.js");
var Chip_Action_Slide = require("../Chip.Action.Slide/index.js");
var Chip_Action_Tick = require("../Chip.Action.Tick/index.js");
var Chip_Level_Build = require("../Chip.Level.Build/index.js");
var Chip_Lib_JSON = require("../Chip.Lib.JSON/index.js");
var Chip_Lib_Sound = require("../Chip.Lib.Sound/index.js");
var Chip_Model_Color = require("../Chip.Model.Color/index.js");
var Chip_Model_DieReason = require("../Chip.Model.DieReason/index.js");
var Chip_Model_Direction = require("../Chip.Model.Direction/index.js");
var Chip_Model_Game = require("../Chip.Model.Game/index.js");
var Chip_Model_Item = require("../Chip.Model.Item/index.js");
var Chip_Model_Level = require("../Chip.Model.Level/index.js");
var Chip_Model_Moving = require("../Chip.Model.Moving/index.js");
var Chip_Model_State = require("../Chip.Model.State/index.js");
var Chip_Model_Tile = require("../Chip.Model.Tile/index.js");
var Chip_Utils = require("../Chip.Utils/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var DOM_HTML_Indexed_InputType = require("../DOM.HTML.Indexed.InputType/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Display = require("../Display/index.js");
var Effect_Aff_Class = require("../Effect.Aff.Class/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Simple_JSON = require("../Simple.JSON/index.js");
var Web_UIEvent_KeyboardEvent = require("../Web.UIEvent.KeyboardEvent/index.js");
var KeyboardDown = (function () {
    function KeyboardDown(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    KeyboardDown.create = function (value0) {
        return function (value1) {
            return new KeyboardDown(value0, value1);
        };
    };
    return KeyboardDown;
})();
var KeyboardUp = (function () {
    function KeyboardUp(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    KeyboardUp.create = function (value0) {
        return function (value1) {
            return new KeyboardUp(value0, value1);
        };
    };
    return KeyboardUp;
})();
var Tick = (function () {
    function Tick(value0) {
        this.value0 = value0;
    };
    Tick.create = function (value0) {
        return new Tick(value0);
    };
    return Tick;
})();
var SetRadius = (function () {
    function SetRadius(value0) {
        this.value0 = value0;
    };
    SetRadius.create = function (value0) {
        return new SetRadius(value0);
    };
    return SetRadius;
})();
var ticksPerSecond = 10;
var soundFile = function (sound) {
    return "sounds/" + (function () {
        if (sound instanceof Chip_Action.PickUpChip) {
            return "CLICK3.WAV";
        };
        if (sound instanceof Chip_Action.Oof) {
            return "OOF3.WAV";
        };
        if (sound instanceof Chip_Action.DoorOpen) {
            return "DOOR.WAV";
        };
        if (sound instanceof Chip_Action.PickUpItem) {
            return "BLIP2.WAV";
        };
        if (sound instanceof Chip_Action.Bummer) {
            return "BUMMER.WAV";
        };
        if (sound instanceof Chip_Action.LevelComplete) {
            return "DITTY1.WAV";
        };
        if (sound instanceof Chip_Action.Steal) {
            return "STRIKE.WAV";
        };
        if (sound instanceof Chip_Action.Teleported) {
            return "TELEPORT.WAV";
        };
        if (sound instanceof Chip_Action.Splash) {
            return "WATER2.WAV";
        };
        throw new Error("Failed pattern match at Chip.Component (line 237, column 32 - line 246, column 25): " + [ sound.constructor.name ]);
    })();
};
var moveAction = function (tiles) {
    return function (pos) {
        return function (movedAt) {
            return function (tick) {
                var v = Data_Map_Internal.lookup(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                    return "y";
                }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                    return "x";
                }))(Data_Ord.ordInt)))(pos)(tiles);
                if (v instanceof Data_Maybe.Just && v.value0 instanceof Chip_Model_Tile.Force) {
                    return true;
                };
                if ((tick - movedAt | 0) >= 1) {
                    return true;
                };
                return false;
            };
        };
    };
};
var loadLevel = function (dictBind) {
    return function (dictMonadAff) {
        return function (number) {
            return function (game) {
                return Control_Bind.bind(dictBind)(Effect_Aff_Class.liftAff(dictMonadAff)(Chip_Lib_JSON.getJSON(Simple_JSON.readRecord()(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
                    return "blocks";
                }))(Simple_JSON.readArray(Simple_JSON.readRecord()(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
                    return "x";
                }))(Simple_JSON.readInt)(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
                    return "y";
                }))(Simple_JSON.readInt)(Simple_JSON.readFieldsNil)()())()())))(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
                    return "chips";
                }))(Simple_JSON.readInt)(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
                    return "grid";
                }))(Simple_JSON.readArray(Simple_JSON.readString))(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
                    return "hint";
                }))(Simple_JSON.readMaybe(Simple_JSON.readString))(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
                    return "name";
                }))(Simple_JSON.readString)(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
                    return "timeLimit";
                }))(Simple_JSON.readMaybe(Simple_JSON.readInt))(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
                    return "trapConnections";
                }))(Simple_JSON.readMaybe(Simple_JSON.readArray(Simple_JSON.readRecord()(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
                    return "button";
                }))(Simple_JSON.readRecord()(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
                    return "x";
                }))(Simple_JSON.readInt)(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
                    return "y";
                }))(Simple_JSON.readInt)(Simple_JSON.readFieldsNil)()())()()))(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
                    return "trap";
                }))(Simple_JSON.readRecord()(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
                    return "x";
                }))(Simple_JSON.readInt)(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
                    return "y";
                }))(Simple_JSON.readInt)(Simple_JSON.readFieldsNil)()())()()))(Simple_JSON.readFieldsNil)()())()()))))(Simple_JSON.readFieldsNil)()())()())()())()())()())()())()()))("levels/" + (Data_Show.show(Data_Show.showInt)(number) + ".json"))))(function (v) {
                    if (v instanceof Data_Maybe.Just) {
                        var builtLevel = Chip_Level_Build.build(v.value0);
                        return Control_Applicative.pure(((dictMonadAff.MonadEffect0()).Monad0()).Applicative0())({
                            level: builtLevel,
                            levelNum: number,
                            name: v.value0.name,
                            state: Chip_Model_State.Init.value,
                            intactLevel: builtLevel,
                            moving: game.moving,
                            radius: game.radius
                        });
                    };
                    if (v instanceof Data_Maybe.Nothing) {
                        return Control_Applicative.pure(((dictMonadAff.MonadEffect0()).Monad0()).Applicative0())(game);
                    };
                    throw new Error("Failed pattern match at Chip.Component (line 213, column 3 - line 221, column 25): " + [ v.constructor.name ]);
                });
            };
        };
    };
};
var processAction = function (dictBind) {
    return function (dictMonadAff) {
        return function (game) {
            return function (v) {
                if (v instanceof Chip_Action.Complete) {
                    return Control_Bind.bind(dictBind)(processAction(dictBind)(dictMonadAff)(game)(new Chip_Action.PlaySound(Chip_Action.LevelComplete.value)))(function (v1) {
                        return loadLevel(dictBind)(dictMonadAff)(game.levelNum + 1 | 0)(game);
                    });
                };
                if (v instanceof Chip_Action.Die) {
                    return Data_Functor.map((dictBind.Apply0()).Functor0())(function (v1) {
                        return {
                            state: new Chip_Model_State.Dead(v.value0),
                            intactLevel: v1.intactLevel,
                            level: v1.level,
                            levelNum: v1.levelNum,
                            moving: v1.moving,
                            name: v1.name,
                            radius: v1.radius
                        };
                    })(processAction(dictBind)(dictMonadAff)(game)(new Chip_Action.PlaySound(Chip_Action.Bummer.value)));
                };
                if (v instanceof Chip_Action.PlaySound) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(dictBind)(Effect_Class.liftEffect(dictMonadAff.MonadEffect0())(Chip_Lib_Sound.play(new Chip_Lib_Sound.Sound(soundFile(v.value0), 1.0))))(function () {
                        return Control_Applicative.pure(((dictMonadAff.MonadEffect0()).Monad0()).Applicative0())(game);
                    });
                };
                throw new Error("Failed pattern match at Chip.Component (line 224, column 22 - line 234, column 16): " + [ v.constructor.name ]);
            };
        };
    };
};
var runAction = function (dictBind) {
    return function (dictMonadAff) {
        return function (dictMonadState) {
            return function (f) {
                return Control_Bind.bind(dictBind)(Control_Monad_State_Class.get(dictMonadState))(function (v) {
                    return Control_Applicative.when(((dictMonadAff.MonadEffect0()).Monad0()).Applicative0())(Chip_Model_Game.notDead(v))((function () {
                        var v1 = f(v.level);
                        return Control_Bind.bind(dictBind)(Chip_Utils.foldlM(((dictMonadAff.MonadEffect0()).Monad0()).Applicative0())(dictBind)(processAction(dictBind)(dictMonadAff))({
                            level: v1.result,
                            levelNum: v.levelNum,
                            state: v.state,
                            name: v.name,
                            intactLevel: v.intactLevel,
                            moving: v.moving,
                            radius: v.radius
                        })(v1.actions))(Control_Monad_State_Class.put(dictMonadState));
                    })());
                });
            };
        };
    };
};
var moveTo = function (dictBind) {
    return function (dictMonadState) {
        return function (dictMonadAff) {
            return function (moving) {
                if (moving instanceof Chip_Model_Moving.Released) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(dictBind)(Control_Monad_State_Class.modify_(dictMonadState)(function (v) {
                        var $55 = {};
                        for (var $56 in v) {
                            if ({}.hasOwnProperty.call(v, $56)) {
                                $55[$56] = v[$56];
                            };
                        };
                        $55.moving = Chip_Model_Moving.Unpressed.value;
                        return $55;
                    }))(function () {
                        return runAction(dictBind)(dictMonadAff)(dictMonadState)(Chip_Action_MovePlayer.movePlayer(true)(moving.value0));
                    });
                };
                if (moving instanceof Chip_Model_Moving.Pressed) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(dictBind)(Control_Monad_State_Class.modify_(dictMonadState)(function (v) {
                        var $59 = {};
                        for (var $60 in v) {
                            if ({}.hasOwnProperty.call(v, $60)) {
                                $59[$60] = v[$60];
                            };
                        };
                        $59.moving = new Chip_Model_Moving.Processed(moving.value0);
                        return $59;
                    }))(function () {
                        return runAction(dictBind)(dictMonadAff)(dictMonadState)(Chip_Action_MovePlayer.movePlayer(true)(moving.value0));
                    });
                };
                if (moving instanceof Chip_Model_Moving.Processed) {
                    return runAction(dictBind)(dictMonadAff)(dictMonadState)(Chip_Action_MovePlayer.movePlayer(true)(moving.value0));
                };
                if (moving instanceof Chip_Model_Moving.Unpressed) {
                    return Control_Applicative.pure(((dictMonadAff.MonadEffect0()).Monad0()).Applicative0())(Data_Unit.unit);
                };
                throw new Error("Failed pattern match at Chip.Component (line 181, column 17 - line 190, column 25): " + [ moving.constructor.name ]);
            };
        };
    };
};
var helpSection = Halogen_HTML_Elements.div_([ Halogen_HTML_Core.text("Controls:"), Halogen_HTML_Elements.div_([ Halogen_HTML_Core.text("WASD or arrows to move") ]), Halogen_HTML_Elements.div_([ Halogen_HTML_Core.text("Space for pause") ]), Halogen_HTML_Elements.div_([ Halogen_HTML_Core.text("R to restart a level") ]), Halogen_HTML_Elements.div_([ Halogen_HTML_Core.text("N go to next level") ]), Halogen_HTML_Elements.div_([ Halogen_HTML_Core.text("P go to previous level") ]), Halogen_HTML_Elements.div_([ Halogen_HTML_Core.text("Select view radius:"), Halogen_HTML_Elements.input([ Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType)(DOM_HTML_Indexed_InputType.InputRange.value), Halogen_HTML_Properties.min(3.0), Halogen_HTML_Properties.max(16.0), Halogen_HTML_Properties.value("6"), Halogen_HTML_Events.onValueChange((function () {
    var $160 = Data_Maybe.fromMaybe(3);
    return function ($161) {
        return Data_Maybe.Just.create(SetRadius.create($160(Data_Int.fromString($161))));
    };
})()) ]) ]) ]);
var handleQuery = function (v) {
    if (v instanceof KeyboardUp) {
        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v1) {
            if (v1.moving instanceof Chip_Model_Moving.Pressed) {
                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                    var $67 = {};
                    for (var $68 in v2) {
                        if ({}.hasOwnProperty.call(v2, $68)) {
                            $67[$68] = v2[$68];
                        };
                    };
                    $67.moving = new Chip_Model_Moving.Released(v1.moving.value0);
                    return $67;
                }))(function () {
                    return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
                });
            };
            if (v1.moving instanceof Chip_Model_Moving.Processed) {
                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                    var $71 = {};
                    for (var $72 in v2) {
                        if ({}.hasOwnProperty.call(v2, $72)) {
                            $71[$72] = v2[$72];
                        };
                    };
                    $71.moving = Chip_Model_Moving.Unpressed.value;
                    return $71;
                }))(function () {
                    return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
                });
            };
            return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
        });
    };
    if (v instanceof KeyboardDown) {
        var raiseMoveEvent = function (direction) {
            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v1) {
                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Applicative.when(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Eq.eq(Chip_Model_State.eqState)(v1.state)(Chip_Model_State.Init.value))(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                    var $79 = {};
                    for (var $80 in v2) {
                        if ({}.hasOwnProperty.call(v2, $80)) {
                            $79[$80] = v2[$80];
                        };
                    };
                    $79.state = Chip_Model_State.Alive.value;
                    return $79;
                })))(function () {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                        var $82 = {};
                        for (var $83 in v2) {
                            if ({}.hasOwnProperty.call(v2, $83)) {
                                $82[$83] = v2[$83];
                            };
                        };
                        $82.moving = new Chip_Model_Moving.Pressed(direction);
                        return $82;
                    }))(function () {
                        return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
                    });
                });
            });
        };
        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v1) {
            var $91 = {
                state: v1.state,
                key: Web_UIEvent_KeyboardEvent.key(v.value0)
            };
            if ($91.key === "r") {
                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                    var $92 = {};
                    for (var $93 in v2) {
                        if ({}.hasOwnProperty.call(v2, $93)) {
                            $92[$93] = v2[$93];
                        };
                    };
                    $92.level = v1.intactLevel;
                    $92.state = Chip_Model_State.Init.value;
                    return $92;
                }))(function () {
                    return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
                });
            };
            if ($91.state instanceof Chip_Model_State.Dead) {
                return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
            };
            if ($91.key === " " && $91.state instanceof Chip_Model_State.Pause) {
                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                    var $98 = {};
                    for (var $99 in v2) {
                        if ({}.hasOwnProperty.call(v2, $99)) {
                            $98[$99] = v2[$99];
                        };
                    };
                    $98.state = Chip_Model_State.Alive.value;
                    return $98;
                }))(function () {
                    return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
                });
            };
            if ($91.key === " ") {
                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                    var $103 = {};
                    for (var $104 in v2) {
                        if ({}.hasOwnProperty.call(v2, $104)) {
                            $103[$104] = v2[$104];
                        };
                    };
                    $103.state = Chip_Model_State.Pause.value;
                    return $103;
                }))(function () {
                    return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
                });
            };
            if ($91.state instanceof Chip_Model_State.Pause) {
                return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
            };
            if ($91.key === "s") {
                return raiseMoveEvent(Chip_Model_Direction.Down.value);
            };
            if ($91.key === "a") {
                return raiseMoveEvent(Chip_Model_Direction.Left.value);
            };
            if ($91.key === "w") {
                return raiseMoveEvent(Chip_Model_Direction.Up.value);
            };
            if ($91.key === "d") {
                return raiseMoveEvent(Chip_Model_Direction.Right.value);
            };
            if ($91.key === "ArrowDown") {
                return raiseMoveEvent(Chip_Model_Direction.Down.value);
            };
            if ($91.key === "ArrowLeft") {
                return raiseMoveEvent(Chip_Model_Direction.Left.value);
            };
            if ($91.key === "ArrowUp") {
                return raiseMoveEvent(Chip_Model_Direction.Up.value);
            };
            if ($91.key === "ArrowRight") {
                return raiseMoveEvent(Chip_Model_Direction.Right.value);
            };
            if ($91.key === "n") {
                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(loadLevel(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query_HalogenM.monadAffHalogenM(Effect_Aff_Class.monadAffAff))(v1.levelNum + 1 | 0)))(Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM)))(function () {
                    return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
                });
            };
            if ($91.key === "p" && v1.levelNum > 1) {
                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(loadLevel(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query_HalogenM.monadAffHalogenM(Effect_Aff_Class.monadAffAff))(v1.levelNum - 1 | 0)))(Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM)))(function () {
                    return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
                });
            };
            return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
        });
    };
    if (v instanceof Tick) {
        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v1) {
            if (v1.state instanceof Chip_Model_State.Init) {
                return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value0));
            };
            if (v1.state instanceof Chip_Model_State.Dead) {
                return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value0));
            };
            if (v1.state instanceof Chip_Model_State.Pause) {
                return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value0));
            };
            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(runAction(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query_HalogenM.monadAffHalogenM(Effect_Aff_Class.monadAffAff))(Halogen_Query_HalogenM.monadStateHalogenM)(Chip_Action_Tick.tick))(function () {
                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Applicative.when(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Int.odd(v1.level.tick))(runAction(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query_HalogenM.monadAffHalogenM(Effect_Aff_Class.monadAffAff))(Halogen_Query_HalogenM.monadStateHalogenM)(function ($162) {
                    return Chip_Action_MovePlayer.checkForEnemies(Chip_Action_AI.actAI($162));
                })))(function () {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Applicative.when(Halogen_Query_HalogenM.applicativeHalogenM)(moveAction(v1.level.tiles)(v1.level.player.pos)(v1.level.player.movedAt)(v1.level.tick))(moveTo(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query_HalogenM.monadStateHalogenM)(Halogen_Query_HalogenM.monadAffHalogenM(Effect_Aff_Class.monadAffAff))(v1.moving)))(function () {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(runAction(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query_HalogenM.monadAffHalogenM(Effect_Aff_Class.monadAffAff))(Halogen_Query_HalogenM.monadStateHalogenM)(Chip_Action_Slide.slide))(function () {
                            return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value0));
                        });
                    });
                });
            });
        });
    };
    throw new Error("Failed pattern match at Chip.Component (line 104, column 1 - line 104, column 86): " + [ v.constructor.name ]);
};
var handleAction = function (v) {
    return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
        var $136 = {};
        for (var $137 in v1) {
            if ({}.hasOwnProperty.call(v1, $137)) {
                $136[$137] = v1[$137];
            };
        };
        $136.radius = v.value0;
        return $136;
    });
};
var div = function (classes) {
    return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_(classes) ]);
};
var dl = function (dictShow) {
    return function (term) {
        return function (description) {
            return div("data-list")([ div("term")([ Halogen_HTML_Core.text(term) ]), div("description")([ Halogen_HTML_Core.text("888"), div((function () {
                var $140 = Data_Maybe.isNothing(description);
                if ($140) {
                    return "value -low";
                };
                return "value";
            })())([ Halogen_HTML_Core.text(Data_Maybe.maybe("---")(Data_Show.show(dictShow))(description)) ]) ]) ]);
        };
    };
};
var renderSidebar = function (v) {
    var toSeconds = function (ticksLeft) {
        return Data_Int.ceil(Data_Int.toNumber(ticksLeft) / Data_Int.toNumber(ticksPerSecond));
    };
    var hint = Chip_Model_Level.visibleHint(v.level);
    return div("sidebar")([ Halogen_HTML_Elements.div_([ dl(Data_Show.showInt)("LEVEL")(new Data_Maybe.Just(v.levelNum)), dl(Data_Show.showInt)("TIME")(Data_Functor.map(Data_Maybe.functorMaybe)(toSeconds)(v.level.ticksLeft)), dl(Data_Show.showInt)("CHIPS LEFT")(new Data_Maybe.Just(v.level.chipsLeft)) ]), (function () {
        if (hint instanceof Data_Maybe.Just) {
            return div("hint")([ Halogen_HTML_Core.text(hint.value0) ]);
        };
        if (hint instanceof Data_Maybe.Nothing) {
            return div("inventory")([ Display.tilesRowElem([ (function () {
                var $144 = v.level.inventory.red > 0;
                if ($144) {
                    return new Display.Tile(new Chip_Model_Tile.Item(new Chip_Model_Item.Key(Chip_Model_Color.Red.value)));
                };
                return Display.Floor.value;
            })(), (function () {
                var $145 = v.level.inventory.cyan > 0;
                if ($145) {
                    return new Display.Tile(new Chip_Model_Tile.Item(new Chip_Model_Item.Key(Chip_Model_Color.Cyan.value)));
                };
                return Display.Floor.value;
            })(), (function () {
                var $146 = v.level.inventory.yellow > 0;
                if ($146) {
                    return new Display.Tile(new Chip_Model_Tile.Item(new Chip_Model_Item.Key(Chip_Model_Color.Yellow.value)));
                };
                return Display.Floor.value;
            })(), (function () {
                if (v.level.inventory.green) {
                    return new Display.Tile(new Chip_Model_Tile.Item(new Chip_Model_Item.Key(Chip_Model_Color.Green.value)));
                };
                return Display.Floor.value;
            })() ]), Display.tilesRowElem([ (function () {
                if (v.level.inventory.skiSkates) {
                    return new Display.Tile(new Chip_Model_Tile.Item(Chip_Model_Item.SkiSkates.value));
                };
                return Display.Floor.value;
            })(), (function () {
                if (v.level.inventory.suctionBoots) {
                    return new Display.Tile(new Chip_Model_Tile.Item(Chip_Model_Item.SuctionBoots.value));
                };
                return Display.Floor.value;
            })(), (function () {
                if (v.level.inventory.fireBoots) {
                    return new Display.Tile(new Chip_Model_Tile.Item(Chip_Model_Item.FireBoots.value));
                };
                return Display.Floor.value;
            })(), (function () {
                if (v.level.inventory.flippers) {
                    return new Display.Tile(new Chip_Model_Tile.Item(Chip_Model_Item.Flippers.value));
                };
                return Display.Floor.value;
            })() ]) ]);
        };
        throw new Error("Failed pattern match at Chip.Component (line 272, column 7 - line 287, column 10): " + [ hint.constructor.name ]);
    })() ]);
};
var dieMessage = function (v) {
    if (v instanceof Chip_Model_DieReason.Drown) {
        return "Ooops! Chip can't swim without flippers!";
    };
    if (v instanceof Chip_Model_DieReason.Burned) {
        return "Ooops! Don't step in the fire without fire boots!";
    };
    if (v instanceof Chip_Model_DieReason.Eaten) {
        return "Ooops! Look out for creatures!";
    };
    if (v instanceof Chip_Model_DieReason.Timed) {
        return "Ooops! Out of time!";
    };
    if (v instanceof Chip_Model_DieReason.BlownUp) {
        return "Ooops! Don't touch the bombs!";
    };
    throw new Error("Failed pattern match at Chip.Component (line 249, column 14 - line 254, column 45): " + [ v.constructor.name ]);
};
var renderMessage = function (v) {
    if (v.state instanceof Chip_Model_State.Init) {
        return [ div("modal -level")([ Halogen_HTML_Core.text(v.name) ]) ];
    };
    if (v.state instanceof Chip_Model_State.Pause) {
        return [ div("modal -pause")([ Halogen_HTML_Core.text("Pause") ]) ];
    };
    if (v.state instanceof Chip_Model_State.Dead) {
        return [ div("modal -dead")([ Halogen_HTML_Core.text(dieMessage(v.state.value0)), Halogen_HTML_Elements.br_, Halogen_HTML_Core.text("Press R to restart") ]) ];
    };
    return [  ];
};
var component = function (initBlank) {
    return function (initLevelNum) {
        var render = function (game) {
            return div("game-container")([ div("content")(Data_Semigroup.append(Data_Semigroup.semigroupArray)(renderMessage(game))(Data_Functor.map(Data_Functor.functorArray)(Display.tilesRowElem)(Display.levelTiles(game)))), renderSidebar(game), helpSection ]);
        };
        var builtLevel = Chip_Level_Build.build(initBlank);
        var initialState = {
            level: builtLevel,
            levelNum: initLevelNum,
            name: initBlank.name,
            state: Chip_Model_State.Init.value,
            intactLevel: builtLevel,
            moving: Chip_Model_Moving.Unpressed.value,
            radius: 6
        };
        return Halogen_Component.mkComponent({
            initialState: Data_Function["const"](initialState),
            render: render,
            "eval": Halogen_Component.mkEval({
                handleAction: handleAction,
                handleQuery: handleQuery,
                receive: Halogen_Component.defaultEval.receive,
                initialize: Halogen_Component.defaultEval.initialize,
                finalize: Halogen_Component.defaultEval.finalize
            })
        });
    };
};
module.exports = {
    component: component,
    SetRadius: SetRadius,
    KeyboardDown: KeyboardDown,
    KeyboardUp: KeyboardUp,
    Tick: Tick,
    processAction: processAction,
    ticksPerSecond: ticksPerSecond
};
